module.exports = __webpack_public_path__ + "img/icon-state-car.3c443b1f.svg";